import {
  IonIcon,
  IonItem,

  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { statsChartOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./WEPolsky.css";

function WEPolsky() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>

      <IonItem className="ion-hide-sm-up">
        <IonIcon
          icon={statsChartOutline}
          slot="start"
          className="ion-icon"
        ></IonIcon>
        <IonModal
          isOpen={showModal}
          className="ion-modal-popup"
          backdropDismiss="false"
        >
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b>Growth Marketing Consultant @ Polsky</b>
            <br />
            <p>
              From September 2020 to December 2020, I did a part-time internship
              at the Polsky Center for Entrepreneurship and Innovation, where I
              worked on a team with 2 MBA students to assist a small local
              elevator repair company attract more contracts and generatre more
              revenue.{" "}
            </p>
            <br />
          </IonText>

          <IonButton className="ion-button" onClick={() => setShowModal(false)}>
            Close
          </IonButton>
        </IonModal>

        <IonButton className="ion-button" onClick={() => setShowModal(true)}>
          Show
        </IonButton>
      </IonItem>
    </div>
  );
}

export default WEPolsky;
